<div>
  <button
    type="button"
    class="btn-close d-none d-md-block"
    (click)="modal.dismiss()"
  >
    <i class="gpicon-close"></i>
  </button>

  <div class="video">
    <youtube-player
      #youtubePlayer
      id="youtubePlayer"
      [videoId]="videoId"
      [playerVars]="playerVars"
      suggestedQuality="hd1080"
      class="video"
    ></youtube-player>
  </div>
</div>
